export const MENUS_MANAGEMENT_PATHS = {
  main: '/config',
  doctor: '/doctor',
  subService: '/sub-service',
  groupService: '/group-service',
  workingSchedule: '/working-schedule',
  clinicRoom: '/clinic-room',
  template: '/template'
}

export const PATIENT_MANAGEMENT_PATHS = {
  main: '/booking',
  primary: '/',
  booking: '/booking',
  receive: '/receive',
  receiveDetail: '/:id',
  payment: '/payment',
  paymentDetail: '/:id',
  prescription: '/prescription',
  dashboard: '/dashboard',
  transaction: '/transaction',
  patient: '/patient',
  patientDetail: '/patient/:id'
}

export const ACCOUNT_MANAGEMENT_PATHS = {
  main: '/account',
  primary: '/',
  clinicInfo: '',
  user: '/user',
  systemSetting: '/system-setting',
  systemSettingDetail: '/:id'
}

export const ROLE_MANAGEMENT_PATHS = {
  main: '/account',
  primary: '/',
  clinicInfo: '',
  user: '/role',
  systemSetting: '/system-setting',
  systemSettingDetail: '/:id'
}

export const EXAM_MANAGEMENT_PATHS = {
  main: '/examination',
  primary: '/',
  exam: '/detail',
  supersonic: '/supersonic',
  subclinical: '/subclinical',
  examDetail: '/:id',
  patient: '/patient',
  patientDetail: '/patient/:id'
}

export const REPO_MANAGEMENT_PATHS = {
  main: '/repo',
  primary: '/',
  inventory: '',
  import: '/import',
  export: '/export'
}

export const HELP_PATHS = {
  main: '/help',
  primary: '/',
  userManual: '/user-manual',
  contact: '/contact'
}
